import TCalendar from '@/components/TCalendar/TCalendar';
import { ICalendarEvent } from '@/components/TCalendar/TCalendar.controller';
import { HeaderPortal } from '@/templates/app-shell/components/header/components/header-portal';
import { Button, ButtonGroup, Grid } from '@chakra-ui/react';
import { t } from 'i18next';
import { DateTime } from 'luxon';
import { Temporal } from 'temporal-polyfill';
import { useMonthViewController } from './month-view.controller';

export function MonthView() {
	const { calendarEventsQuery, handlePlannerClick } = useMonthViewController();

	const events: ICalendarEvent[] = calendarEventsQuery.data?.items
		.filter((e) => {
			if (!e.interval) {
				return false;
			}
			return true;
		})
		.map((c) => {
			return {
				id: c.id,
				color: 'primary',
				title: c.summary,

				start: DateTime.fromMillis(
					Temporal.ZonedDateTime.from(`${c.interval!.inclusiveStart.dateTime}[${c.interval!.inclusiveStart.timeZone}]`)
						.epochMilliseconds
				),
				end: DateTime.fromMillis(
					Temporal.ZonedDateTime.from(`${c.interval!.exclusiveEnd.dateTime}[${c.interval!.exclusiveEnd.timeZone}]`)
						.epochMilliseconds
				),
			};
		}) as ICalendarEvent[];

	return (
		<>
			<HeaderPortal>
				<Grid alignContent="center" justifyContent="center" gridTemplateColumns="1fr auto" w="full" h="full" px={6}>
					<ButtonGroup isAttached></ButtonGroup>

					<ButtonGroup isAttached variant="outline">
						<Button onClick={handlePlannerClick}>{t('Planner')}</Button>
					</ButtonGroup>
				</Grid>
			</HeaderPortal>
			<TCalendar events={events || []} timeZone={'Europe/Madrid'} month={3} year={2024} />;
		</>
	);
}
